import { render, staticRenderFns } from "./NoticeTask.vue?vue&type=template&id=5e5412d2&scoped=true&"
import script from "./NoticeTask.vue?vue&type=script&lang=js&"
export * from "./NoticeTask.vue?vue&type=script&lang=js&"
import style0 from "./NoticeTask.vue?vue&type=style&index=0&id=5e5412d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5412d2",
  null
  
)

export default component.exports